// JavaScript Document
document.addEventListener("DOMContentLoaded", function(event) {
  // array with texts to type in typewriter
  var dataText = [
    "Dynamic Results.",
    "Premium Quality.",
    "Rich, Creamy, Fresh.",
    "Professional Grade.",
    "Ultra Luxurious."
  ];

  // type one text in the typwriter
  // keeps calling itself until the text is finished
  function typeWriter(text, i, fnCallback) {
    // chekc if text isn't finished yet
    if (i < text.length) {
      // add next character to h1
      document.querySelector(".blinking-words").innerHTML =
        text.substring(0, i + 1) + '<span aria-hidden="true" class="type-cursor"></span>';

      // wait for a while and call this function again for next character
      setTimeout(function() {
        typeWriter(text, i + 1, fnCallback);
      }, 100);
    } else if (typeof fnCallback == "function") {
      // text finished, call callback if there is a callback function
      // call callback after timeout
      setTimeout(fnCallback, 3000);
    }
  }
  // start a typewriter animation for a text in the dataText array
  function StartTextAnimation(i) {
    if (typeof dataText[i] == "undefined") {
      setTimeout(function() {
        StartTextAnimation(0);
      }, 3000);
    }
    // check if dataText[i] exists
    if (i < dataText[i].length) {
      // text exists! start typewriter animation
      typeWriter(dataText[i], 0, function() {
        // after callback (and whole text has been animated), start next text
        StartTextAnimation(i + 1);
      });
    }
  }
  // start the text animation
  StartTextAnimation(0);


    //----------------- START BLINKING WORDS 1-------------------------------
  var dataText1 = [
    "Your Skin",
    "Your Care",
    "Yourself!",
    "Build Your Own."
  ];

  // type one text in the typwriter
  // keeps calling itself until the text is finished
  function typeWriter1(text, i, fnCallback1) {
    // check if text isn't finished yet
    if (i < text.length) {
      // add next character to h1
      document.querySelector(".blinking-words1").innerHTML =
        text.substring(0, i + 1) + '<span aria-hidden="true" class="type-cursor"></span>';

      // wait for a while and call this function again for next character
      setTimeout(function() {
        typeWriter1(text, i + 1, fnCallback1);
      }, 100);
    } else if (typeof fnCallback1 == "function") {
      // text finished, call callback if there is a callback function
      // call callback after timeout
      setTimeout(fnCallback1, 3000);
    }
  }
  // start a typewriter1 animation for a text in the dataText1 array
  function StartTextAnimation1(i) {
    if (typeof dataText1[i] == "undefined") {
      setTimeout(function() {
        StartTextAnimation1(0);
      }, 3000);
    }
    // check if dataText1[i] exists
    if (i < dataText1[i].length) {
      // text exists! start typewriter1 animation
      typeWriter1(dataText1[i], 0, function() {
        // after callback (and whole text has been animated), start next text
        StartTextAnimation1(i + 1);
      });
    }
  }
  // start the text animation
  StartTextAnimation1(0);



  
    // START BLINKING WORDS 2
  var dataText2 = [
    "Product Integrity",
    "Current GMP",
     "On Time",
    "Cost In Mind",
    "Dedicated Pharmacists",
    "Technology First"
  ];

  // type one text in the typwriter
  // keeps calling itself until the text is finished
  function typeWriter2(text, i, fnCallback2) {
    // chekc if text isn't finished yet
    if (i < text.length) {
      // add next character to h1
      document.querySelector(".blinking-words2").innerHTML =
        text.substring(0, i + 1) + '<span aria-hidden="true" class="type-cursor"></span>';

      // wait for a while and call this function again for next character
      setTimeout(function() {
        typeWriter2(text, i + 1, fnCallback2);
      }, 100);
    } else if (typeof fnCallback2 == "function") {
      // text finished, call callback if there is a callback function
      // call callback after timeout
      setTimeout(fnCallback2, 3000);
    }
  }
  // start a typewriter2 animation for a text in the dataText2 array
  function StartTextAnimation2(i) {
    if (typeof dataText2[i] == "undefined") {
      setTimeout(function() {
        StartTextAnimation2(0);
      }, 3000);
    }
    // check if dataText2[i] exists
    if (i < dataText2[i].length) {
      // text exists! start typewriter2 animation
      typeWriter2(dataText2[i], 0, function() {
        // after callback (and whole text has been animated), start next text
        StartTextAnimation2(i + 1);
      });
    }
  }
  // start the text animation
  StartTextAnimation2(0);
    

  
  (function(){ 
       var randomh=Math.random();
       var e = document.getElementsByTagName("script")[0];
       var d = document.createElement("script");
       d.src = "https://pwa.shopiapps.in/js/installpwa.js?x="+randomh+"";
       d.type = "text/javascript"; 
       d.async = true;
       d.defer = true;
       e.parentNode.insertBefore(d,e);
   })();
});


